/* istanbul ignore file */
import track from './track';

export default track;
